export default (title) => {
  let markup = '';

  const splitTitle = title.split(' ');
  const titleFirst = splitTitle[0].toLowerCase();

  if (titleFirst === 'the') {
    markup += `<span class="the text-[0.75em] mr-[0.3em]">${splitTitle.splice(0, 1)}</span>`;
  }

  if (splitTitle.length) {
    markup += `<span class="font-serif font-semibold">${splitTitle.join(' ')}</span>`;
  }

  return markup;
};
